import { mapValues, findKey } from 'lodash';

import biLogger from '@wix/web-bi-logger';

const createBiLogger = ({ events, defaults, disableBi = false }) => {
  const knownEvents = mapValues(events, (evid) => ({ evid }));

  const biFactory = biLogger
    .factory({ endpoint: 'video' })
    .updateDefaults(defaults)
    .setEvents(knownEvents);

  biFactory.setMuted(disableBi);

  if (disableBi) {
    biFactory.withTransformer((event) => {
      const eventName = findKey(knownEvents, { evid: event.evid });
      console.log('log bi:', eventName, event);
      return event;
    });
  }

  return biFactory.logger();
};

export default createBiLogger;
